import { NgModule } from '@angular/core';
import { SingleTextPipe } from './single-text-from-list.pipe';

@NgModule({
  declarations: [SingleTextPipe],
  exports: [SingleTextPipe],
})
export class SingleTextPipeModule {}
